<template>
  <div class="progress">
    <div class="progress-bar"
         role="progressbar"
         v-bind:style="fullWidth"
         v-bind:aria-valuenow="width"
         aria-valuemin="0"
         aria-valuemax="100">
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: ['complete'],
  data() {
    return {
      width: 0,
    }
  },
  created() {
    this.width = this.complete;
  },
  computed: {
    fullWidth() {
      return `width:${this.width}%`;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    isText() {
      if (isNaN(this.width)) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.width = ''
      }
    }
  },
}
</script>

<style scoped>

</style>
